import { Modal, Button } from "antd";
import { IoIosWarning } from "react-icons/io";
import styles from "./ModalTimeCorrect.module.scss";

const ModalTimeCorrection = ({ isTimeCorrect, handleToggleTimeStatus }) => {
  return (
    <Modal
      open={isTimeCorrect}
      centered
      footer={false}
      closeIcon={<div></div>}
      className={styles.modal_time}
    >
      <div className={styles.container}>
        <div className={styles.icon}>
          <IoIosWarning />
        </div>
        <div className={styles.detail}>
          <div className={styles.upper}>เวลาไม่ถูกต้อง</div>
          <div className={styles.lower}>
            กรุณาตั้งค่าเวลาอัตโนมัติ และ ตั้งค่า Time Zone เป็น Indochina Time
            GMT/UTC+07:00 ก่อนเข้าใช้งานระบบ
          </div>
        </div>
        <div className={styles.button}>
          <Button
            type="primary"
            style={{ width: "40%" }}
            onClick={handleToggleTimeStatus}
          >
            ตกลง
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTimeCorrection;
